<template>
    <div class="mobile-nav-toggle" :class="rootClasses">
        <button type="button" class="mobile-nav-toggle--btn" @click="onRequestMobileNavigation">
            <span class="mobile-nav-toggle--wrap">
                <span class="mobile-nav-toggle--text" v-text="translate('MENU.BURGER_LABEL')"></span>
                <cmp-icon class="mobile-nav-toggle--icon" size="large" symbol="burger"></cmp-icon>
            </span>
        </button>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { mapFilters } from 'util/vue/map-filters';
    import bemMixin from 'framework/mixins/bem';


    export default {
        mixins: [
            bemMixin('mobile-nav-toggle'),
        ],
        computed: {
            ...mapGetters(['navigation']),
            rootClasses() {
                return [
                    this.bemIf(this.navigation.mobile.isOpen, 'is-open'),
                ];
            },
        },
        methods: {
            ...mapActions(['setMobileNavigation']),
            ...mapFilters(['translate']),
            onRequestMobileNavigation() {
                this.setMobileNavigation({ isOpen: !this.navigation.mobile.isOpen });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/mobile-nav-toggle/index.vue?03c86c62